import { SliderProducts } from '@/features/slider-products/slider-products';

export class MainPopular {
	private readonly element: HTMLElement;
	private readonly media: MediaQueryList = matchMedia('(width >= 700px)');
	private slider: SliderProducts;

	constructor(element) {
		if (!element) return;
		this.element = element;

		this.init();
	}

	private setSlider = (): void => {
		if (this.media.matches && !this.slider) this.slider = new SliderProducts(this.element);
		else if (this.media.matches && this.slider) this.slider.init();
		else if (!this.media.matches && this.slider) this.slider.init();
	};

	public init = () => {
		this.setSlider();
		this.media.addEventListener('change', this.setSlider);
	};
}
